<template>
    <div class="report-container">
        <h5 class="title">
            {{ $t('reports.dashboards.evaluations') }}
        </h5>
        <span
            class="total-count"
            v-html="`${$t('reports.dashboards.totalText', { total })}`"
        />
        <apexchart
            type="bar"
            :height="200"
            :series="countByStatus"
            :options="chartOptions"
        />
    </div>
</template>

<script>
import evaluationsMixin from './evaluationsMixin'
export default {
    mixins: [evaluationsMixin],
    methods: {
        setEvaluationsCount(response) {
            this.setTotal(response)
            this.setCountByStatus(response)
        },
        setTotal({ total }) {
            this.total = total ? total : 0
        },
        setCountByStatus({ sent, pending, declined, unanswered }) {
            this.countByStatus = [
                {
                    name: this.labels.sent.text,
                    data: [this.parseCount(sent)],
                },
                {
                    name: this.labels.pending.text,
                    data: [this.parseCount(pending)],
                },
                {
                    name: this.labels.declined.text,
                    data: [this.parseCount(declined)],
                },
                {
                    name: this.labels.unanswered.text,
                    data: [this.parseCount(unanswered)],
                },
            ]
        },

        parseCount(count) {
            return count > 0 ? count : null
        },
    },
    data() {
        return {
            countByStatus: [],
            total: 0,
            type: 'all',
        }
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    stacked: true,
                    toolbar: {
                        show: false,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 20,
                        barHeight: '50%',
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                labels: ['Total'],
                legend: {
                    show: 'true',
                    position: 'bottom',
                    fontSize: '13px',
                    fontFamily: 'Roboto',
                    markers: {
                        width: '15px',
                        height: '15px',
                    },
                },
                colors: Object.values(this.colors),
                grid: {
                    xaxis: {
                        lines: {
                            show: false,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },
                xaxis: {
                    max: this.total,
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                    },
                },
                yaxis: {
                    labels: {
                        show: false,
                    },
                },
            }
        },
    },
}
</script>

<style lang="sass" scoped>
@import './default_style'

.total-count
    display: flex
    width: 100%
    justify-content: center
    margin-bottom: 15px
    border-bottom: 1px solid $darkBlue
    padding-bottom: 5px
    color: black
::v-deep
    .apexcharts-bar-series.apexcharts-plot-series
        clip-path: inset(0% 0% 0% 0% round 45px) !important
</style>
